




















import Vue from 'vue'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'

export default Vue.extend({
  computed: {
    moment(): moment.Moment {
      return moment(this.value)
    },
    wrappedValue: {
      get(): Date {
        return moment(this.value).toDate()
      },
      set(value: string | Date) {
        this.$emit('input', moment(value).toDate())
      },
    },
  },
  components: {
    DatePicker,
  },
  data() {
    return {
      // Use moment.js instead of the default
      momentFormat: {
        // Date to String
        stringify: date => {
          return date
            ? moment(date)
                .locale(this.$i18n.locale)
                .format('LLL')
            : ''
        },
        // String to Date
        parse: value => {
          return value ? moment(value, 'LLL', this.$i18n.locale).toDate() : null
        },
      },
    }
  },
  methods: {
    timeIsOutOfBounds(date: Date): boolean {
      if (!this.min && !this.max) {
        return false
      }
      const m = moment(date)
      return (this.min && m.isBefore(this.min)) || (this.max && m.isAfter(this.max))
    },
    dateIsOutOfBounds(date: Date): boolean {
      if (!this.min && !this.max) {
        return false
      }
      const m = moment(date)
      return (
        (this.min && moment(date).isBefore(this.min, 'date')) ||
        (this.max && moment(date).isAfter(this.max, 'date'))
      )
    },
  },
  props: {
    value: {
      required: true,
      type: [String, Date],
    },
    min: {
      type: [String, Date, Object],
    },
    max: {
      type: [String, Date, Object],
    },
    lang: {
      type: String,
      default() {
        return this.$i18n.locale || 'en'
      },
    },
  },
})
